import React from 'react';
import Auth from './Auth';
import PriceOptions from './PriceOptions';
import ForgotPassword from './ForgotPassword';
import Payments from './Payments';
import Account from './Account';
import PaymentProcessor from './PaymentProcessor';
import ChangePassword from './ChangePassword';
import DeleteAccount from './GDPR/DeleteAccount';
import ExportData from './GDPR/ExportData';
import ConfirmAction from './GDPR/ConfirmAction';
import SetNewPassword from './SetNewPassword';
import HistoryTable from './HistoryTable';
import Unsubscribe from './Unsubscribe';

import {
    LOGIN_FORM,
    REGISTER_FORM,
    PRICE_OPTS_FORM,
    FORGOT_PASSWORD_FORM,
    PAYMENTS_FORM,
    MY_ACCOUNT_FORM,
    PAYMENT_PROCESSOR_FORM,
    CHANGE_PASSWORD_FORM,
    DELETE_ACCOUNT_FORM,
    EXPORT_DATA_FORM,
    SET_NEW_PASSWORD_FORM,
    CONFIRM_GDPR_DELETE_FORM,
    CONFIRM_GDPR_EXPORT_FORM,
    PURCHASE_HISTORY_FORM,
    SUBSCRIPTIONS_FORM,
    UNSUBSCRIBE_FORM,
} from '../../constants/forms';

export const makeForm = (name, props = {}) => {
    switch (name) {
        case LOGIN_FORM:
        case REGISTER_FORM:
            return <Auth {...props} />;
        case PRICE_OPTS_FORM:
            return <PriceOptions {...props} />;
        case FORGOT_PASSWORD_FORM:
            return <ForgotPassword {...props} />;
        case PAYMENTS_FORM:
            return <Payments {...props} />;
        case MY_ACCOUNT_FORM:
            return <Account {...props} />;
        case PAYMENT_PROCESSOR_FORM:
            return <PaymentProcessor {...props} />;
        case CHANGE_PASSWORD_FORM:
            return <ChangePassword {...props} />;
        case DELETE_ACCOUNT_FORM:
            return <DeleteAccount {...props} />;
        case EXPORT_DATA_FORM:
            return <ExportData {...props} />;
        case SET_NEW_PASSWORD_FORM:
            return <SetNewPassword {...props} />;
        case CONFIRM_GDPR_DELETE_FORM:
            return <ConfirmAction {...props} type="delete" />;
        case CONFIRM_GDPR_EXPORT_FORM:
            return <ConfirmAction {...props} type="export" />;
        case PURCHASE_HISTORY_FORM:
        case SUBSCRIPTIONS_FORM:
            return <HistoryTable {...props} />;
        case UNSUBSCRIBE_FORM:
            return <Unsubscribe {...props} />;
        default:
            return null;
    }
};



// WEBPACK FOOTER //
// ./src/containers/Forms/index.js